<div>
  <div class="outer-container">
    <app-price-selection
      *ngIf="formDetails"
      [formDetails]="formDetails"
      [selectedValues]="selectedValues"
      (onSelectFilter)="searchSalesData($event)"
      (onResetFilter)="resetFilter($event)"
    >
    </app-price-selection>

    <div class="table-box">
      <div class="title">
        <span class="head">SUMMARY</span>
      </div>
      <span class="sub-head">Sales Bridge</span>
      <div class="flex">
        View Data in &nbsp;&nbsp;
        <mat-button-toggle-group #group="matButtonToggleGroup" [value]="suffix">
          <mat-button-toggle [value]="1" (change)="setSuffix(1)">
            Thousands
          </mat-button-toggle>
          <mat-button-toggle [value]="2" (change)="setSuffix(2)">
            Millions
          </mat-button-toggle>
          <mat-button-toggle [value]="0" (change)="setSuffix(0)">
            <mat-icon>block</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="column-group"> 
        <span style="border-right: 2px solid white;">Channel Type</span>
        <span style="border-right: 2px solid white;">External</span>
        <span style="border-right: 2px solid white;">Internal</span>
        <span>Total</span>
      </div>

      <div class="summary-table">
        <div class="headerRow header">
          <div class="cell">
            <span style="width: 200px; font-weight: 700">
              {{ tableHead | titlecase }}</span
            >
          </div>
          <div class="cell" (click)="sortColumn('base', 'integer')">
            <span>Current Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Base'
                }
              "
            ></ng-template>
          </div>

          <div class="cell" (click)="sortColumn('attr', 'integer')">
            <span>Price Impact</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Attr'
                }
              "
            ></ng-template>
          </div>

          <div class="cell" (click)="sortColumn('comparable_base', 'integer')">
            <span>Base Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Comparable Base'
                }
              "
            ></ng-template>
          </div>
          <div class="cell" (click)="sortColumn('pure', 'integer')">
            <span>Price Realized</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Pure Price Impact'
                }
              "
            ></ng-template>
          </div>

          <div class="cell" (click)="sortColumn('mix', 'integer')">
            <span>Current Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Mix Impact'
                }
              "
            ></ng-template>
          </div>

          <div class="cell" (click)="sortColumn('discPure', 'integer')">
            <span>Price Impact</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Mix Impact'
                }
              "
            ></ng-template>
          </div>
          <div class="cell" (click)="sortColumn('discMix', 'integer')">
            <span>Base Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Disc Mix Impact'
                }
              "
            ></ng-template>
          </div>

          <div
            class="cell"
            style="background-color: #e4e4e4"
            (click)="sortColumn('totalPrice', 'integer')"
          >
            <span>Price Realized %</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Total Price Impact'
                }
              "
            ></ng-template>
          </div>

          <div class="cell" (click)="sortColumn('volume', 'integer')">
            <span>Current Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Volume Impact'
                }
              "
            ></ng-template>
          </div>

          <div
            class="cell"
            style="background-color: #e4e4e4"
            (click)="sortColumn('discVolume', 'integer')"
          >
            <span>Price Impact</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Disc Volume Impact'
                }
              "
            ></ng-template>
          </div>
          <div
            class="cell"
            style="background-color: #e4e4e4"
            (click)="sortColumn('totalVolume', 'integer')"
          >
            <span>Base Sales</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Total Volume Impact'
                }
              "
            ></ng-template>
          </div>
          <div
            class="cell"
            style="background-color: #e4e4e4"
            (click)="sortColumn('productMix', 'integer')"
          >
            <span>Prce Realized</span>
            <ng-template
              *ngTemplateOutlet="
                sortTemplate;
                context: {
                  type: 'Product Mix'
                }
              "
            ></ng-template>
          </div>
        </div>

        <!-- body -->
        <ng-container *ngFor="let col of channelData; index as i">
          <div
            class="{{ i % 2 == 0 ? 'row' : 'rowClr' }} {{
              i === 0 ? 'margin' : ''
            }}"
            [class.selected]="channelHidden[i]"
            [class.active-customer_name]="activeChannel === col.id"
          >
            <ng-template
              *ngTemplateOutlet="
                colTemplate;
                context: {
                  col: col,
                  i: i,
                  hidden: channelHidden[i],
                  level: 0,
                  type: 'channel'
                }
              "
            ></ng-template>
          </div>
          <ng-container *ngFor="let colBusiness of col.business; index as ci">
            <div
              class="{{ ci % 2 == 0 ? 'rowClr' : 'row' }}"
              [class.hidden]="!channelHidden[i]"
            >
              <ng-template
                *ngTemplateOutlet="
                  colTemplate;
                  context: {
                    col: colBusiness,
                    i: i,
                    itemIndex: ci,
                    hidden: businessHidden[ci],
                    level: 1,
                    type: 'business'
                  }
                "
              ></ng-template>
            </div>
            <ng-container
              *ngFor="
                let colCustomer of col.business[colBusiness.businessIndex]
                  .customer;
                index as ei
              "
            >
              <div
                class="{{ ei % 2 == 0 ? 'row' : 'rowClr' }}"
                [class.hidden]="!channelHidden[i] || !businessHidden[ci]"
              >
                <ng-template
                  *ngTemplateOutlet="
                    colTemplate;
                    context: {
                      col: colCustomer,
                      i: i,
                      itemIndex: ei,
                      hidden: segmentHidden[ei],
                      level: 2,
                      type: 'customer'
                    }
                  "
                ></ng-template>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <ng-template
      #colTemplate
      let-col="col"
      let-i="i"
      let-level="level"
      let-hidden="hidden"
      let-type="type"
      let-itemIndex="itemIndex"
    >
      <div class="{{ col.hierarchy === 'Total' ? 'bold' : 'plain' }}">
        <div class="cell header-cell">
          <div class="channel">
            <span [ngStyle]="{ left: level + 'rem', position: 'relative' }">
              <div *ngIf="selectedButton == 'All'">
                <mat-icon
                  *ngIf="level !== 2 && col.hierarchy !== 'Total'"
                  class="more-icon"
                  aria-hidden="false"
                  aria-label="more detail"
                  (click)="getParentData(i, itemIndex, type, col)"
                  >{{
                    hidden ? "remove_circle_outline" : "add_circle_outline"
                  }}</mat-icon
                >
              </div>
              <!-- <mat-icon
            *ngIf="level == 2"
            class="more-icon"
            aria-hidden="false"
            aria-label="more detail"
            >keyboard_arrow_up</mat-icon
          > -->
              <!-- <div class="elipsis" [matTooltip]="col.hierarchy"> -->
              {{ col.hierarchy }}
              <!-- </div> -->
            </span>
          </div>
        </div>
        <!-- <div class="cell price-cell"></div> -->

        <div class="cell price-cell">
          {{ col.base | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.attr | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.comparable_base | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.pure | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.mix | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.discPure | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.discMix | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.totalPrice | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.volume | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.discVolume | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.totalVolume | suffixConditional : 1 : suffix }}
        </div>
        <div class="cell price-cell">
          {{ col.productMix | suffixConditional : 1 : suffix }}
        </div>
      </div>
    </ng-template>
  </div>
  <ng-template #sortTemplate let-type="type"
    ><mat-icon
      aria-hidden="false"
      class="sort-icon"
      *ngIf="activeSort === type"
      >{{ sortOrderAsc ? "arrow_drop_up" : "arrow_drop_down" }}</mat-icon
    >
    <span class="default-sort" *ngIf="activeSort !== type">
      <mat-icon aria-hidden="false" class="default-icon"
        >arrow_drop_up</mat-icon
      >
      <mat-icon aria-hidden="false" class="default-icon"
        >arrow_drop_down</mat-icon
      >
    </span></ng-template
  >
</div>
